import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Card, Spin } from 'antd';
import { useLocation } from 'react-router-dom';
import ProposalCompanySelect from '../../components/Proposal/ProposalCompanySelect';
import ControlAddress from '../../components/Companies/ControlAddress';
import Parametres from '../../components/Proposal/Parametres';
import ProposalService from '../../services/ProposalService';

const ProposalReport: React.FC = () => {
    const location = useLocation();
    const [proposal, setProposal] = useState<any>(null);
    const [companyId, setCompanyId] = useState<any>(null);
    const [selectedAddressId, setSelectedAddressId] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const proposalId = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const rawProposalId = params.get('proposalId');
        const parsedProposalId = Number(rawProposalId);
        return Number.isFinite(parsedProposalId) && parsedProposalId > 0
            ? parsedProposalId
            : null;
    }, [location.search]);

    useEffect(() => {
        if (!proposalId) {
            setError('Rapor detayları için geçerli bir teklif seçilmelidir.');
            setLoading(false);
            return;
        }

        const fetchReportDetails = async () => {
            try {
                setLoading(true);
                setError(null);
                const response: any = await ProposalService.getReportDetails(proposalId);
                setProposal(response.data);
                setCompanyId(response.data?.company?.id ?? null);
                setSelectedAddressId(response.data?.address?.id ?? null);
            } catch (err) {
                console.error('Rapor detayları alınamadı:', err);
                setError('Rapor detayları alınırken bir hata oluştu.');
            } finally {
                setLoading(false);
            }
        };

        fetchReportDetails();
    }, [proposalId]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
                <Spin />
            </div>
        );
    }

    if (error) {
        return <Alert type="error" message={error} showIcon />;
    }

    return (
        <div style={{ paddingBottom: 120 }}>
            <ProposalCompanySelect setCompanyId={setCompanyId} companyId={companyId} />

            <Card className='br-30px mt-16px'>
                <ControlAddress
                    companyId={companyId}
                    type={true}
                    setSelectedAddress={setSelectedAddressId}
                    selectedAddressId={selectedAddressId}
                    isEdit={false}
                />
            </Card>

            <Card className="br-30px mt-16px">
                <Parametres
                    companyId={companyId}
                    addressId={selectedAddressId}
                    attributes={proposal?.attributes || []}
                    isEdit={false}
                    authorizedPersonIds={[]}
                    mode="report"
                    reportProposalId={proposalId}
                />
            </Card>
        </div>
    );
};

export default ProposalReport;
